import classNames from "classnames";
import { FunctionComponent } from "react";

interface ButtonProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  variant: "primary" | "secondary" | "secondary-red";
}

const Button: FunctionComponent<ButtonProps> = ({ variant, className, ...divProps }) => {
  return (
    <div
      className={classNames(
        {
          "bg-main-to text-white": variant === "primary",
          "border hover:bg-main-to hover:text-white border-main-to text-main-to": variant === "secondary",
          "border hover:bg-red-500 hover:text-white border-red-500 text-red-500": variant === "secondary-red",
        },
        "h-[32px] rounded-full flex items-center justify-center cursor-pointer select-none transform active:scale-90",
        className
      )}
      {...divProps}
    ></div>
  );
};

export default Button;
